import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#FFDA44\" d=\"M3.514 3.514a11.97 11.97 0 0 0-3.48 9.384L12.897.033a11.97 11.97 0 0 0-9.384 3.481\"></path><path fill=\"#0052B4\" d=\"M4.285 21.19c4.715 3.967 11.763 3.732 16.2-.706 4.438-4.437 4.673-11.485.706-16.2z\"></path><path fill=\"#000\" d=\"m11.956 11.517 1.034-.56-1.034-.56a3.655 3.655 0 0 0-3.05-3.05l-.56-1.034-.56 1.034a3.655 3.655 0 0 0-3.049 3.05l-1.034.56 1.034.56a3.655 3.655 0 0 0 3.05 3.049l.56 1.034.56-1.034a3.655 3.655 0 0 0 3.05-3.05m-3.61 1.527a2.087 2.087 0 1 1 0-4.174 2.087 2.087 0 0 1 0 4.174\"></path><path fill=\"#D80027\" d=\"m8.348 9.39.451.783h.904l-.452.783.452.783H8.8l-.452.782-.452-.782h-.904l.452-.783-.452-.783h.904z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }